import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_KEPSEK } from "@/lib/nav";
import { FilterBar } from "@/components/FilterBar";

const F_EMPTY = { peminjam: "", judul: "", status: "" };

export default function PeminjamanKepsek() {
  const [all, setAll] = useState([]);
  const [filters, setFilters] = useState(F_EMPTY);
  const [applied, setApplied] = useState(F_EMPTY);

  const load = useCallback(async () => { try { const { data } = await api.get("/peminjaman"); setAll(data); } catch (e) { console.error(e); } }, []);
  useEffect(() => { load(); }, [load]);

  const items = all.filter((l) => {
    if (applied.peminjam && !(l.peminjam_nama || "").toLowerCase().includes(applied.peminjam.toLowerCase())) return false;
    if (applied.judul && !(l.judul_buku || "").toLowerCase().includes(applied.judul.toLowerCase())) return false;
    if (applied.status && l.status !== applied.status) return false;
    return true;
  });

  return (
    <Layout nav={NAV_KEPSEK}>
      <PageTitle title="Daftar Peminjaman (Read-only)" />
      <FilterBar
        filters={filters} setFilters={setFilters}
        onApply={() => setApplied({ ...filters })}
        onReset={() => { setFilters(F_EMPTY); setApplied(F_EMPTY); }}
        dataTestidPrefix="kepsek-pinjam-filter"
        fields={[
          { key: "peminjam", type: "text", label: "Peminjam", placeholder: "Cari nama" },
          { key: "judul", type: "text", label: "Judul Buku", placeholder: "Cari judul" },
          { key: "status", type: "select", label: "Status", options: [{ v: "pending", label: "Pending" }, { v: "dipinjam", label: "Dipinjam" }, { v: "dikembalikan", label: "Dikembalikan" }, { v: "ditolak", label: "Ditolak" }] },
        ]}
      />
      <section className="pp-card pp-freeze overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="pp-table-header">
            <th className="text-left px-5 py-3">Peminjam</th>
            <th className="text-left px-5 py-3">Buku</th>
            <th className="text-left px-5 py-3">Tgl Pinjam</th>
            <th className="text-left px-5 py-3">Tgl Kembali</th>
            <th className="text-left px-5 py-3">Status</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-400 italic">Belum ada peminjaman.</td></tr>}
            {items.map((l) => (
              <tr key={l.id} className="pp-row">
                <td className="px-5 py-3 font-medium">{l.peminjam_nama}</td>
                <td className="px-5 py-3 text-slate-700">{l.judul_buku}</td>
                <td className="px-5 py-3 text-slate-600">{l.tanggal_pinjam || "—"}</td>
                <td className="px-5 py-3 text-slate-600">{l.tanggal_kembali || "—"}</td>
                <td className="px-5 py-3"><span className={l.status === "dipinjam" ? "pp-badge-info" : l.status === "dikembalikan" ? "pp-badge-success" : l.status === "ditolak" ? "pp-badge-danger" : "pp-badge-warning"}>{l.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </Layout>
  );
}
